// Vercel Analytics integration for performance tracking
import { inject } from '@vercel/analytics';
import logger from './logger';

// Initialize Vercel Analytics
export const initializeVercelAnalytics = () => {
    if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
        inject();
        logger.info('ANALYTICS', 'Info');
    }
};

// Track custom events with Vercel Analytics
export const trackVercelEvent = (eventName, properties = {}) => {
    if (typeof window !== 'undefined' && window.va) {
        window.va('track', eventName, properties);
    }
};

// Track page views
export const trackVercelPageView = (url) => {
    if (typeof window !== 'undefined' && window.va) {
        window.va('track', 'pageview', { url });
    }
};

export default {
    initializeVercelAnalytics,
    trackVercelEvent,
    trackVercelPageView
};


